<template>
  <div class="screen-main">
    <div class="attrSec" ref="carousel">
      <div class="attrSec-list" ref="carousel">
        <bsAttrCard
          :label="$l(item.text)"
          :value="item.value"
          @click.native="handleCardClick(idx)"
          v-for="(item, idx) in carouselList"
          :key="idx"
          :class="{ 'is-active': isCardActive(idx) }"
          :style="cardStyle(idx)"
        />
      </div>
    </div>

    <div class="bsPanel ub-flex">
      <div class="bsPanel-c">
        <div class="searchBar" :class="{ 'is-fixed': !isSearchShow }">
          <div
            class="searchBar-cbtn"
            @click="isSearchShow = !isSearchShow"
            v-if="isSearchShow"
          >
            <i class="el-icon-d-arrow-left"></i>
          </div>
          <div
            class="searchBar-btn"
            @click="isSearchShow = !isSearchShow"
            v-else
          >
            <i class="el-icon-search"></i>
          </div>
          <div class="toolbar" v-if="isSearchShow">
            <el-form
              class="toolbar-form"
              :inline="true"
              v-model="form"
              label-width="6em"
            >
              <el-form-item :label="$l('所属城市')">
                <el-input
                  v-model="form.city"
                  :placeholder="$l('所属城市')"
                ></el-input>
              </el-form-item>
              <el-form-item :label="$l('地盘名称')">
                <el-input
                  v-model="form.domainName"
                  :placeholder="$l('地盘名称')"
                ></el-input>
              </el-form-item>
              <el-form-item>
                <el-button
                  icon="el-icon-search"
                  type="primary"
                  @click="search"
                  :disabled="!isSearch"
                  >搜索</el-button
                >
              </el-form-item>
            </el-form>
          </div>
        </div>
        <!-- <el-table
          ref="filterTable"
          :data="tableData"
          highlight-current-row
          height="100%"
          style="width: 100%; z-index: 1000"
          v-loading.lock="loading"
          :element-loading-text="$l('加载中')"
          stripe
        > -->
        <el-table
          ref="filterTable"
          :data="tableData"
          highlight-current-row
          height="100%"
          style="width: 100%; z-index: 1000"
          v-screen-loading.lock="loading"
          :element-loading-text="$l('加载中')"
          stripe
          @row-dblclick="handleRowDblclick"
        >
          <el-table-column
            :label="$l('序号')"
            type="index"
            min-width="80"
            align="center"
          ></el-table-column>
          <el-table-column
            :label="$l('城市')"
            prop="city"
            align="center"
            min-width="120"
          ></el-table-column>
          <el-table-column
            :label="$l('地盘名称')"
            prop="domainName"
            align="center"
            min-width="120"
          ></el-table-column>
          <el-table-column
            :label="$l('大楼名称')"
            prop="buildingName"
            align="center"
            min-width="120"
          ></el-table-column>
          <el-table-column
            :label="$l('梯号')"
            prop="elevatorNum"
            align="center"
            min-width="120"
          ></el-table-column>
          <el-table-column
            :label="$l('工号')"
            prop="jobNum"
            align="center"
            min-width="150"
          ></el-table-column>
          <el-table-column
            :label="$l('保养单位')"
            prop="grtFlg"
            align="center"
            min-width="150"
            :formatter="formatterGrtFlg"
          ></el-table-column>
          <el-table-column
            :label="$l('电梯状态')"
            prop="elevatorStatus"
            align="center"
            min-width="150"
            :formatter="elevatorStatusFormatter"
          >
          </el-table-column>
          <el-table-column
            :label="$l('遥监设备状态')"
            prop="isactive"
            align="center"
            min-width="150"
            :formatter="monitorStatusFormatter"
          ></el-table-column>
          <el-table-column
            :label="$l('电梯品牌')"
            prop="brand"
            align="center"
            min-width="150"
          ></el-table-column>
          <el-table-column
            :label="$l('梯龄')"
            prop="elevatorAge"
            align="center"
            min-width="150"
          ></el-table-column>
          <el-table-column
            :label="$l('注册代码')"
            prop="registerCode"
            align="center"
            min-width="150"
          ></el-table-column>
          <el-table-column
            :label="$l('详细备注')"
            prop="remark"
            align="center"
            min-width="150"
            v-if="hasFieldPermission('详细备注')"
          ></el-table-column>
          <el-table-column
            :label="$l('实时监视')"
            fixed="right"
            align="center"
            v-if="hasPermissionByName('monitor')"
          >
            <template slot-scope="scope">
              <el-button
                v-if="scope.row.isactive"
                type="em"
                light
                circle
                @click="handleMonitor(scope.$index, scope.row)"
              >
                <svgicon name="monitor" class></svgicon>
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          :current-page="pageConfig.currentPage"
          :page-sizes="pageConfig.pageSizes"
          :page-size="pageConfig.pageSize"
          :total="pageConfig.total"
          @size-change="handlePageSizeChange"
          @current-change="handleCurrentPageChange"
          layout="total, sizes, prev, pager, next, jumper"
        ></el-pagination>
      </div>
    </div>

    <div class="fixTime">{{ $l("数据最近更新时间") }} {{ lastUpdateTime }}</div>
  </div>
</template>

<script>
import panel from "@/components/panel.vue";
import breadcrumb from "@/components/breadcrumb.vue";
import bsAttrCard from "@/components/bsAttrCard.vue";
import global from "@/mixins/global.js";
export default {
  name: "displayDeviceMonitor",
  mixins: [global],
  components: {
    panel,
    breadcrumb,
    bsAttrCard,
  },
  props: {
    loaded: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    var validateCustomerName = (rule, value, callback) => {
      if (value.trim() == "") {
        callback(new Error(this.$l("请输入客户名称")));
      } else {
        callback();
      }
    };
    var validateAddress = (rule, value, callback) => {
      if (value.trim() == "") {
        callback(new Error(this.$l("请输入详细地址")));
      } else {
        callback();
      }
    };
    var validateReporter = (rule, value, callback) => {
      if (value.trim() == "") {
        callback(new Error(this.$l("请输入保障联系人")));
      } else {
        callback();
      }
    };
    var validateTelNum = (rule, value, callback) => {
      if (
        isNaN(value) ||
        value.trim().length != 11 ||
        value.indexOf(".") >= 0
      ) {
        callback(new Error(this.$l("请输入11位数字的手机号")));
      } else {
        callback();
      }
    };
    return {
      isSearchShow: false,
      form: {
        pageNum: 0,
        pageSize: 0,
        city: null,
        domainName: null,
        jobNum: null,
        buildingName: null,
        registerCode: null,
        elevatorType: null,
        grtFlg: "",
        maintainStatus: "-1",
        elevatorStatus: "-1",
        monitorStatus: "-1",
        dataPermissionList: [],
      },
      tableData: null,
      loading: false,
      fullLoading: false,
      elevatorStatusArr: [
        { type: 0, text: "故障停梯", value: 0 },
        { type: 1, text: "困人", value: 0 },
      ],
      elevatorStatusArr2: [
        { type: 2, text: "遥监在线", value: 0 },
        { type: 3, text: "检修", value: 0 },
        { type: 4, text: "故障停梯", value: 0 },
        { type: 5, text: "困人", value: 0 },
        { type: 0, text: "今日保养", value: 0 },
      ],
      monitorStatusArr: [
        { value: 1, text: "正常监视" },
        { value: 0, text: "未正常监视" },
      ],
      editFaultReportForm: {
        faultId: "",
        patrolId: "",
        jobNum: "",
        customerName: "",
        address: "",
        reporter: "",
        telNum: "",
        num: 0,
        captcha: "",
        ctoken: "",
      },
      faultReportFormRules: {
        customerName: [
          { validator: validateCustomerName, trigger: "blur" },
          {
            max: 50,
            message: this.$l("长度不能超过 50 个字符"),
            trigger: "blur",
          },
        ],
        address: [
          { validator: validateAddress, trigger: "blur" },
          {
            max: 100,
            message: this.$l("长度不能超过 100 个字符"),
            trigger: "blur",
          },
        ],
        reporter: [
          { validator: validateReporter, trigger: "blur" },
          {
            max: 50,
            message: this.$l("长度不能超过 50 个字符"),
            trigger: "blur",
          },
        ],
        telNum: [{ validator: validateTelNum, trigger: "blur" }],
      },
      editFaultReportDialogVisible: false,
      isViewFaultReport: false,
      src: "",
      isSearch: true,
      lastUpdateTime: null,
      statisticType: null,
      activeType: null,
      carouselIndex: 3,
      carouselTimer: null,
      instantReset: false,
    };
  },
  watch: {
    carouselIndex(val) {
      var items = this.elevatorStatusArr2;
      var type = items[(val + 2) % items.length].type;
      this.initChildData(type, 1);
    },
  },
  computed: {
    carouselList() {
      return [...this.elevatorStatusArr2, ...this.elevatorStatusArr2];
    },
  },
  methods: {
    handlePageSizeChange(val) {
      this.pageConfig.pageSize = val;
      this.initData();
    },
    handleCurrentPageChange(val) {
      this.pageConfig.currentPage = val;
      this.initData();
    },
    handleMonitor(index, row) {
      if (row.isactive != 1) {
        this.$message.error(
          this.$l("遥监设备断开，无法实时监视，请及时恢复。")
        );
        return;
      }
      this.$router.push({
        path: "/manage/monitor",
        query: {
          row: row,
        },
      });
    },
    //双击行数据跳转到运行诊断大屏并加载当前电梯数据
    handleRowDblclick(row) {
      this.$router.push({
        name: "deviceBigScreen",
        params: { jobNum: row.jobNum },
      });
    },
    search() {
      this.pageConfig.currentPage = 1;
      this.statisticType = null;
      this.activeType = null;
      this.initData();
    },
    initChildData(data, type) {
      this.isSearch = false;
      this.loading = true;
      if (type) {
        if (typeof data == "number") {
          this.statisticType = data;
          this.activeType = data;
        } else {
          this.statisticType = null;
          this.activeType = null;
        }
        this.pageConfig.currentPage = 1;
      }
      this.form.pageNum = this.pageConfig.currentPage;
      this.form.pageSize = this.pageConfig.pageSize;
      let params = {};
      if (this.statisticType == 4) {
        this.form.elevatorStatus = 0;
      } else if (this.statisticType == 5) {
        this.form.elevatorStatus = 1;
      } else {
        this.form.elevatorStatus = "-1";
      }
      for (const key in this.form) {
        params[key] = this.form[key];
      }
      if (this.statisticType !== null) {
        params["statisticType"] = this.statisticType;
      }
      this.tableData = [];
      this.$http
        .post(this.$apiConfig.search_device_patrol_url, params)
        .then((response) => {
          this.loading = false;
          let result = response.data;
          if (result.code == 0) {
            this.pageConfig.total = result.data.total;
            this.tableData = result.data.result;
            this.lastUpdateTime = this.$common.formatCurrentDateTime();
          }
          this.isSearch = true;
        })
        .catch((error) => {
          this.loading = false;
          this.isSearch = true;
          this.$sentry.captureException(error);
        });
    },
    initData() {
      this.isSearch = false;
      this.loading = true;
      this.form.pageNum = this.pageConfig.currentPage;
      this.form.pageSize = this.pageConfig.pageSize;
      this.tableData = [];
      this.statisticsElevatorStatus();
      let params = {};
      for (const key in this.form) {
        params[key] = this.form[key];
      }
      this.$http
        .post(this.$apiConfig.search_device_patrol_url, params)
        .then((response) => {
          this.loading = false;
          let result = response.data;
          if (result.code == 0) {
            this.pageConfig.total = result.data.total;
            this.tableData = result.data.result;
            this.lastUpdateTime = this.$common.formatCurrentDateTime();
          }
          this.isSearch = true;
        })
        .catch((error) => {
          this.loading = false;
          this.isSearch = true;
          this.$sentry.captureException(error);
        });
    },
    formatterGrtFlg(row) {
      if (row.grtFlg === "Y") {
        return "日立电梯";
      } else {
        return "非日立保养";
      }
    },
    elevatorStatusFormatter(row) {
      if (row.processType == 1) {
        if (row.finishDate == null && row.rescueTime == null) {
          if (row.boxUp == "是") {
            return "困人";
          }
          return "故障停梯";
        }
      }
      if (row.isactive == 1) {
        return "正常";
      }
      return "未知";
    },
    monitorStatusFormatter(row) {
      if (row.isactive == 1) {
        return this.monitorStatusArr[0].text;
      }
      return this.monitorStatusArr[1].text;
    },
    viewFaultReport(index, row) {
      this.editFaultReportDialogVisible = true;
      this.isViewFaultReport = true;
      this.$http
        .get(this.$apiConfig.get_device_patrol_fault_url + row.faultId)
        .then((response) => {
          let result = response.data;
          if (result.code == 0) {
            for (let key in this.editFaultReportForm) {
              this.editFaultReportForm[key] = result.data[key];
            }
          } else {
            this.message(result.code, result.msg);
          }
        })
        .catch((error) => {
          this.errorMessage();
          this.$sentry.captureException(error);
        });
    },
    openFaultReport(index, row) {
      this.editFaultReportDialogVisible = true;
      this.isViewFaultReport = false;
      for (const key in this.editFaultReportForm) {
        if (key == "num") {
          this.editFaultReportForm[key] = 0;
        } else {
          this.editFaultReportForm[key] = "";
        }
      }
      this.editFaultReportForm.patrolId = row.patrolId;
      this.editFaultReportForm.jobNum = row.jobNum;
      this.editFaultReportForm.faultId = "";
      this.getCaptcha();
    },
    submitFaultReport() {
      this.$refs.editFaultReportForm.validate((valid) => {
        if (valid) {
          if (this.editFaultReportForm.captcha.trim().length != 6) {
            this.message(1, "请输入验证码，长度6个字符");
            return;
          }
          let ctoken = localStorage.getItem("ctoken");
          this.editFaultReportForm.ctoken = ctoken;
          localStorage.removeItem("ctoken");
          this.$http
            .post(
              this.$apiConfig.save_device_patrol_fault_url,
              this.editFaultReportForm
            )
            .then((response) => {
              let result = response.data;
              this.message(result.code, result.msg);
              if (result.code == 0) {
                this.initChildData(this.rowData, 0);
                this.editFaultReportDialogVisible = false;
              } else {
                this.getCaptcha();
              }
            })
            .catch((error) => {
              this.errorMessage(0);
              this.getCaptcha();
              this.$sentry.captureException(error);
            });
        } else {
          return false;
        }
      });
    },
    getCaptcha() {
      this.$http
        .get(this.$apiConfig.get_captcha_url, {
          params: {
            t: new Date().getTime(),
            token: localStorage.getItem("ctoken"),
          },
        })
        .then((response) => {
          let result = response.data;
          if (result.code == 0) {
            localStorage.setItem("ctoken", result.data.token);
            this.src = "data:image/jpeg;base64," + result.data.img;
          } else {
            localStorage.removeItem("ctoken");
          }
        })
        .catch((error) => {
          localStorage.removeItem("ctoken");
          this.$sentry.captureException(error);
        });
    },
    statisticsElevatorStatus() {
      this.form.type = 1;
      this.elevatorStatusArr2.forEach((item, index) => {
        item.value = 0;
      });
      let params = {};
      for (const key in this.form) {
        params[key] = this.form[key];
      }
      this.$http
        .post(this.$apiConfig.statistics_elevator_status_count_url, params)
        .then((response) => {
          let result = response.data;
          if (result.code == 0) {
            let data = result.data;
            let otherVal = 0;
            data.forEach((item, index) => {
              let flag = false;
              this.elevatorStatusArr2.map((o) => {
                if (o.type == item.name) {
                  o.value = item.value;
                  flag = true;
                }
              });
              if (!flag) {
                otherVal += item.value;
              }
            });
            if (otherVal > 0) {
              this.elevatorStatusArr2[5].value += otherVal;
            }
          }
        })
        .catch((error) => {
          this.$sentry.captureException(error);
        });
    },
    refresh(row) {
      row.icon = "el-icon-loading";
      this.$http
        .post(this.$apiConfig.search_device_patrol_url, {
          patrolId: row.patrolId,
          pageNum: 1,
          pageSize: 1,
        })
        .then((response) => {
          row.icon = "el-icon-refresh";
          let result = response.data;
          if (result.code == 0) {
            const datas = result.data.result;
            if (datas.length == 1) {
              const data = datas[0];
              for (let key in data) {
                row[key] = data[key];
              }
            }
          }
        })
        .catch((error) => {
          row.icon = "el-icon-refresh";
          this.$sentry.captureException(error);
        });
    },
    updateStatus(row) {
      this.fullLoading = true;
      this.$http
        .post(this.$apiConfig.update_device_patrol_status_url, {
          patrolId: row.patrolId,
          jobNum: row.jobNum,
        })
        .then((response) => {
          this.fullLoading = false;
          let result = response.data;
          this.message(result.code, result.msg);
          if (result.code == 0) {
            const data = result.data;
            for (let i = 0; i < this.tableData.length; i++) {
              let item = this.tableData[i];
              if (item.patrolId == data.patrolId) {
                item.domainName = data.domainName;
                if (data.elevatorStatus != null) {
                  item.elevatorStatus = data.elevatorStatus;
                }
                if (data.monitorStatus != null) {
                  item.monitorStatus = data.monitorStatus;
                }
                if (data.isactive != null) {
                  item.isactive = data.isactive;
                }
                item.remark = data.remark;
              }
            }
          }
        })
        .catch((error) => {
          this.fullLoading = false;
          this.errorMessage(0);
          this.$sentry.captureException(error);
        });
    },
    isCardActive(idx) {
      return idx === this.carouselIndex + 2;
    },
    cardStyle(idx) {
      var offset = this.carouselIndex + 2 - idx;
      var container = this.$refs.carousel;
      if (!container) return {};
      var vw = window.innerWidth / 1920;
      var w = offset === 0 ? 356 : 316;
      var cardW = w * vw;
      var gap = 30 * vw;
      var step = cardW + gap;
      var x = offset * step;
      // var arcY = offset * offset * 8 * vw;
      var arcY = offset * offset * 10 * vw;
      var absOff = Math.abs(offset);
      // var scale = 1 - absOff * 0.08;
      var scale = 1;
      // var opacity = absOff > 2 ? 0 : 1 - Math.max(0, absOff - 1) * 0.3;
      var opacity = 1;
      var transition = this.instantReset ? "none" : "all 0.5s ease";
      return {
        position: "absolute",
        left: "50%",
        top: "25%",
        width: cardW + "px",
        opacity: opacity,
        transform:
          "translateX(calc(-50% + " +
          x +
          "px)) translateY(" +
          -arcY +
          "px) scale(" +
          scale +
          ")",
        transition: transition,
        zIndex: 10 - absOff,
        pointerEvents: absOff > 2 ? "none" : "auto",
      };
    },
    startCarousel() {
      this.stopCarousel();
      this.carouselTimer = setInterval(() => {
        this.carouselIndex--;
        if (this.carouselIndex < 0) {
          this.instantReset = true;
          this.carouselIndex = this.elevatorStatusArr2.length - 1;
          this.$nextTick(() => {
            this.instantReset = false;
          });
        }
      }, 10000);
    },
    stopCarousel() {
      if (this.carouselTimer) {
        clearInterval(this.carouselTimer);
        this.carouselTimer = null;
      }
    },
    handleCardClick(idx) {
      var n = this.elevatorStatusArr2.length;
      var target = (((idx - 2) % n) + n) % n;
      if (target !== this.carouselIndex) {
        this.carouselIndex = target;
        this.stopCarousel();
        this.startCarousel();
      }
    },
  },
  mounted() {
    if (this.loaded) {
      this.statisticsElevatorStatus();
    }
    this.startCarousel();
    this.$nextTick(() => {
      this.initChildData(
        this.elevatorStatusArr2[
          (this.carouselIndex + 2) % this.elevatorStatusArr2.length
        ].type,
        1
      );
    });
  },
  beforeDestroy() {
    this.stopCarousel();
  },
};
</script>
<style lang="scss" scoped>
.screen-main {
  flex: 1;
  min-height: 10px;
  position: relative;
  // background: url(../../assets/img/largeScreen/largeScreenMapBgc.png) no-repeat;
  // background-size: 100% 100%;
  display: flex;
  flex-direction: column;
  padding: vh(18) vw(20) 0 vw(20);
  // gap: vw(20);
}
.attrSec {
  position: relative;
  overflow: hidden;
  height: vh(287);
  background: url(../../assets/img/largeScreen/attrSec_bg.png) no-repeat top
    center;
  background-size: 100% 100%;
  &-list {
    position: relative;
    height: 100%;
    margin: 0 4%;
    overflow: hidden;
  }
  .bsAttrCard {
    cursor: pointer;
  }
}

.searchBar {
  display: flex;
  align-items: center;
  margin-bottom: vh(16);
  &.is-fixed {
    position: fixed;
    left: 0;
    top: 32%;
    z-index: 9999;
  }
  &-btn {
    height: 44px;
    width: 60px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-image: linear-gradient(179deg, #69d7fa 0%, #4169f4 100%);
    color: #fff;
    border-radius: 0 8px 8px 0;
    font-size: 20px;
  }
  &-cbtn {
    height: 44px;
    width: 60px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(#3863e9, 0.2);
    color: #87b9ff;
    border-radius: 8px;
    font-size: 20px;
  }
  .toolbar {
    padding-top: 0;
    padding-left: 2em;
    ::v-deep .el-form-item__label {
      display: inline-block;
      color: var(--bs-color-text-regular);
    }
  }

  .el-form-item {
    margin-bottom: 0;
  }
}
.bsPanel-c {
  padding: 0 vw(28) vw(12);
}
.fixTime {
  bottom: vh(28);
  left: vw(300);
  color: var(--bs-color-text-secondary);
}
// .device {
//   /deep/ .dialog-form {
//     .el-input {
//       .el-input__inner {
//         width: 400px;
//       }
//     }
//     .el-input-number {
//       .el-input-number__decrease {
//         border-top-left-radius: 10em;
//         border-bottom-left-radius: 10em;
//       }
//       .el-input-number__increase {
//         border-top-right-radius: 10em;
//         border-bottom-right-radius: 10em;
//       }
//       .el-input__inner {
//         width: 200px;
//       }
//     }
//     .captcha .el-form-item__content {
//       .el-input {
//         .el-input__inner {
//           border-radius: 0;
//           background: transparent;
//           border-width: 0 0 1px 0;
//           width: 100px;
//         }
//       }
//       .el-input-group__append {
//         background: transparent;
//         border: 0;
//         width: 400px;
//       }
//       img {
//         vertical-align: middle;
//         position: relative;
//         left: -20px;
//       }
//     }
//   }
// }
</style>
